<template>
	<div v-if="!isMobile" id="plane" ref="plane">
		<i aria-hidden="true">✈</i>
	</div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'

const plane = ref(null)
const deg = ref(0)
const ex = ref(0)
const ey = ref(0)
const vx = ref(0)
const vy = ref(0)
const count = ref(0)
const isMobile = ref(false)
let animationId = null

const draw = () => {
	if (!plane.value) return
	plane.value.style.transform = 'rotate(' + deg.value + 'deg)'
	if (count.value < 100) {
		vx.value += ex.value / 100
		vy.value += ey.value / 100
	}
	plane.value.style.left = vx.value + 'px'
	plane.value.style.top = vy.value + 'px'
	count.value++
	animationId = requestAnimationFrame(draw)
}

const handleMouseMove = (e) => {
	if (!plane.value) return
	ex.value = e.pageX - plane.value.offsetLeft - plane.value.clientWidth / 2
	ey.value = e.pageY - plane.value.offsetTop - plane.value.clientHeight / 2
	deg.value = (360 * Math.atan(ey.value / ex.value)) / (2 * Math.PI) + 5
	if (ex.value < 0) {
		deg.value += 180
	}
	count.value = 0
}

onMounted(() => {
	isMobile.value = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

	if (!isMobile.value) {
		// 使用捕获阶段（capture: true），确保在 core-js polyfill（PRNG 熵收集）
		// 于冒泡阶段调用 stopImmediatePropagation() 之前执行
		window.addEventListener('mousemove', handleMouseMove, true)
		animationId = requestAnimationFrame(draw)
	} else {
		// 移动端不启用飞机效果
	}
})

onBeforeUnmount(() => {
	window.removeEventListener('mousemove', handleMouseMove, true)
	if (animationId) {
		cancelAnimationFrame(animationId)
	}
})
</script>

<style lang="less" scoped>
#plane {
	color: #1792ff;
	font-size: 70px;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: default;
	pointer-events: none;
	bottom: -100%;
	left: -100%;
	width: 100px;
	height: 100px;
}
</style>
